package gr.tech.pdfgenerator.components.widgets

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.*
import com.varabyte.kobweb.compose.css.functions.min
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.PageContext
import com.varabyte.kobweb.silk.components.icons.fa.FaX
import com.varabyte.kobweb.silk.components.icons.fa.IconSize
import gr.tech.pdfgenerator.infrastructure.data.GeneratorData
import gr.tech.pdfgenerator.styles.Theme
import gr.tech.pdfgenerator.util.CONSTANTS.FONT_FAMILY2
import gr.tech.pdfgenerator.infrastructure.api.projectSaveToDatabase
import kotlinx.browser.window
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.launch
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Button
import org.jetbrains.compose.web.dom.H2
import org.jetbrains.compose.web.dom.H3
import org.jetbrains.compose.web.dom.Text


@Composable
fun SaveBeforeLeavingModal(
    kobwebRouter: Boolean = false,
    path: String,
    onDismiss: () -> Unit,
    context: PageContext,
    scope: CoroutineScope
) {
    var showLoading by mutableStateOf(false)
    var errorText by mutableStateOf(" ")

    Box(
        modifier = Modifier
            .width(100.dvw)
            .height(100.dvh)
            .position(Position.Fixed)
            .top(0.px)
            .left(0.px)
            .zIndex(19)
            .overflow(Overflow.Hidden)
        ,
        contentAlignment = Alignment.Center
    ) {
        Column(
            modifier = Modifier
                .backgroundColor(Colors.White)
                .borderRadius(20.px)
                .margin(top = 4.cssRem)
                .padding(1.cssRem)
                .zIndex(20)
                .width(min(700.px, 100.percent - 2.cssRem)),
            horizontalAlignment = Alignment.CenterHorizontally,
            verticalArrangement = Arrangement.Top
        ) {
            Row(
                modifier = Modifier
                    .fillMaxWidth(),
                horizontalArrangement = Arrangement.End,
                verticalAlignment = Alignment.CenterVertically
            ) {
                FaX(
                    modifier = Modifier
                        .cursor(Cursor.Pointer)
                        .onClick {
                            onDismiss()
                        }
                        .color(Colors.Grey)
                )
            }

            H2(
                attrs = Modifier
                    .fontFamily(FONT_FAMILY2)
                    .fontSize(1.25.cssRem)
                    .fontWeight(FontWeight.Bold)
                    .toAttrs()
            ) {
                Text("Unsaved Changes!")
            }

            H3(
                attrs = Modifier
                    .fontFamily(FONT_FAMILY2)
                    .fontSize(1.cssRem)
                    .fontWeight(FontWeight.Medium)
                    .margin(bottom = 6.px)
                    .toAttrs()
            ) {
                Text("Are you sure you want to leave without saving current changes?")
            }

            // Show Loading
            if (showLoading) {
                loadingSpinner(
                    iconSize = IconSize.XXL,
                    modifier = Modifier.margin(topBottom = 6.px)
                )
            }

            // Showing Buttons
            else {
                Row(
                    modifier = Modifier
                        .gap(16.px)
                        .fillMaxWidth(),
                    horizontalArrangement = Arrangement.Center
                ) {
                    Button(
                        attrs = Modifier
                            .classNames("button")
                            .backgroundColor(Theme.MediumGreen.rgb)
                            .color(Colors.White)
                            .onClick {
                                scope.launch {
                                    showLoading = true
                                    GeneratorData.saveProject()
                                    val response = projectSaveToDatabase(
                                        id = GeneratorData.project.value.id,
                                        project = GeneratorData.project.value
                                    )
                                    if (response.success && response.data != null) {
                                        if (kobwebRouter) {
                                            context.router.tryRoutingTo(path)
                                        } else {
                                            window.location.href = path
                                        }
                                    } else {
                                        showLoading = false
                                        errorText = "Error saving! Please try again."
                                    }
                                }
                            }
                            .toAttrs()
                    ) {
                        Text("Save & Leave")
                    }

                    Button(
                        attrs = Modifier
                            .classNames("button")
                            .backgroundColor(Colors.PaleVioletRed)
                            .color(Colors.White)
                            .onClick {
                                if (kobwebRouter) {
                                    context.router.tryRoutingTo(path)
                                } else {
                                    window.location.href = path
                                }
                            }
                            .toAttrs()
                    ) {
                        Text("Leave")
                    }

                    Button(
                        attrs = Modifier
                            .classNames("button")
                            .backgroundColor(Colors.LightGray)
                            .color(Colors.White)
                            .onClick {
                                onDismiss()
                            }
                            .toAttrs()
                    ) {
                        Text("Cancel")
                    }
                }
            }
        }

        Box(
            modifier = Modifier
                .fillMaxSize()
                .backgroundColor(Theme.DarkerGray.rgb)
                .position(Position.Fixed)
                .padding(top = 5.cssRem)
                .onClick {
                    onDismiss()
                }
                .zIndex(19),
            contentAlignment = Alignment.TopCenter
        )
    }
}